<app-box-picker *ngIf="!boxSelected" (selectedBox)="newAppSelected($event)" [config]="boxConfig" header="Select an App"></app-box-picker>

<new-connection *ngIf="boxSelected" (connectionChange)="connectionChange($event)" [inputConfig]="connectionConfig"></new-connection>